import React from 'react'
import { Form as FinalForm } from 'react-final-form'
import PropTypes from 'prop-types'
import { validate } from '@models/document_group'
import { RailsForm } from '@support/RailsForm'
import { wrapper } from '@support/AppContainer'
import Form from './Form'

export const Edit = ({
  model,
  signatureTypes,
  dataTypes,
  signerTypes,
  roles,
  users
}) => (
  <RailsForm
    component={FinalForm}
    action='update'
    url={`/document_groups/${model.id}`}
    successUrl={`/document_groups`}
    validate={validate}
    initialValues={model}
    render={(props) => (
      <Form
        {...props}
        title='Alterar Grupo'
        signatureTypes={signatureTypes}
        dataTypes={dataTypes}
        signerTypes={signerTypes}
        roles={roles}
        users={users}
      />
    )}
  />
)

Edit.propTypes = {
  model: PropTypes.object
}

export default wrapper(Edit)
